import { render, staticRenderFns } from "./table-body.vue?vue&type=template&id=481ce23f&scoped=true"
import script from "./table-body.vue?vue&type=script&lang=ts"
export * from "./table-body.vue?vue&type=script&lang=ts"
import style0 from "./table-body.vue?vue&type=style&index=0&id=481ce23f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ce23f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481ce23f')) {
      api.createRecord('481ce23f', component.options)
    } else {
      api.reload('481ce23f', component.options)
    }
    module.hot.accept("./table-body.vue?vue&type=template&id=481ce23f&scoped=true", function () {
      api.rerender('481ce23f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/table/table-body.vue"
export default component.exports